import "./Home.module.css";
import HeaderPrincipale from "@/reusable_sections/Header";
import YourJourneyStartsHere from "./sections/YourJourneyStartsHere";
import CoreIntelligenceTracks from "./sections/CoreIntelligenceTracks";
import ModuliDiProtezioneEspandibili from "./sections/ModuliDiProtezioneEspandibili";
import StandardDiSicurezzaEuropei from "./sections/StandardDiSicurezzaEuropei";
import PopulaireProducten from "./sections/PopulaireProducten";
import FooterInformativo from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <HeaderPrincipale />
      <YourJourneyStartsHere />
      <CoreIntelligenceTracks />
      <ModuliDiProtezioneEspandibili />
      <StandardDiSicurezzaEuropei />
      <PopulaireProducten />
      <FooterInformativo />
    </div>;
}